import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

export const ngxTranslateConfig = {
    loader: provideTranslateHttpLoader({ prefix: './assets/i18n/main/', suffix: '.json' }),
    isolate: false,
    fallbackLng: 'en'
};
